import { atom } from "jotai";
import { PRODUCT_NAV_WIDTH } from "@zapier/canvas-constants";

export const SUMMARY = "summary" as const;

export type SideBarSelected = typeof SUMMARY | "devTools" | "composer" | null;

export const sideBarSelectedAtom = atom<SideBarSelected>(null);

sideBarSelectedAtom.debugLabel = "sideBarSelectedAtom";

// Atom to track the sidebar width for other components to use
export const sideBarWidthAtom = atom<number>(PRODUCT_NAV_WIDTH);

sideBarWidthAtom.debugLabel = "sideBarWidthAtom";
